/**
 * @module Helpers
 * @description Some handy helpers
 */
import { AssetProps } from 'ui/types/common';
const fastlyBase = process.env.imagePath;

/**
 * @function generateIdNumber
 * @description Generate 20 digit random integer
 */
export const generateIdNumber = () => Math.round( Math.random() * 10000000 ).toString() + new Date().getTime();

/**
 * @function getAsset
 * @description Get asset from basePath
 */
export const getAsset = ( asset = '' ) => `${ process.env.basePath || '' }${ asset }`;

/**
 * @function localImage
 * @description Our local image loader
 */
export const localImage = ( asset: AssetProps ) => getAsset( asset.src );

/**
 * @function fastly
 * @description Our local image loader
 */
export const fastly = ( asset: AssetProps ) => {
  const base = new URL( `${ fastlyBase }${ asset.src }` );
  const params = base.searchParams;

  if ( asset.width ) {
    params.set( 'width', asset.width.toString() );
  }

  if ( asset.height ) {
    params.set( 'height', asset.height.toString() );
  }

  return base.href;
};

/**
 * @function fastlyBlur
 * @description Our fastly blur helper
 */
export const fastlyBlur = ( src: string ) => `${ fastlyBase }${ src }?width=10`;

/** Pairs with the Cohesion Utils package. The <MonarchPreampPlacement> componentId prop is a function that passes the asset and needs the componentId returned */
export const getBaseAssetName = ( asset : any ) => {
  let finalName;
  if ( asset && asset.assetName ) {
    const { assetName = '' } = asset;
    finalName = assetName.includes( '@' ) ?
        assetName.split( '@' )[ 0 ].trimEnd() :
        assetName;
  }

  return finalName;
};
